import {
    Logger,
} from 'one-logger';

export class BrowserLogger implements Logger {
    log(content: string): void {
        console.debug(
            content,
        );
    }
}
